import type { PlannedAdmission, PlannedAdmissionDetails, Tag } from '@shared/services/admissions/getLists/types';

interface IAdmissionState {
  admissionDetails?: null | PlannedAdmissionDetails;
  ebsNo: null | string;
  filters: Tag[];
  hasDisplayedFinancialConsents: boolean;
  paymentCallback: null | string;
  paymentType: null | string;
  selectedAdmission?: null | PlannedAdmission;
}

export const initialState: IAdmissionState = {
  ebsNo: null,
  hasDisplayedFinancialConsents: false,
  selectedAdmission: null,
  admissionDetails: null,
  paymentType: null,
  paymentCallback: null,
  filters: [],
};
